import { floatMul,floatDiv } from "@/util/util";

export function earnoutListConfig(getMoney, dateConvert, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow:false,
    // index: true,
    // indexLabel: "序号",
    refreshBtn: true,
    border:true,
    column: [

      // {
      //   label: "序号",
      //   prop: "index",
      //   width: "50",
      //   overHidden: true

      // },
      {
        label: "项目名称",
        placeholder: "请输入项目名称",
        search: true,
        // searchslot: true,
        prop: "projectName",
        width: "230",
        // overHidden: true
      },
      // {
      //   label: "客户名称",
      //   placeholder: "请输入客户名称",
      //   search: true,
      //   prop: "custName",
      //   width: "180",
      //   overHidden: true
      // },

      {
        label: "保理合同",
        prop: "contractName",
        search: true, 
        width: "180",
        overHidden: true
      },
      // {
      //   label: "报价方案",
      //   prop: "name",
      //   slot: true,
      //   width: "180",
      //   overHidden: true
      // },
      {
        label: "批次",
        prop: "investBatch",
        slot: true,
        width: "100",
        overHidden: true
      },


      {
        label: "合同期限(天)",
        prop: "leaseTerm",
        width: "100",
        overHidden: true
      },
      {
        label: "首次还款日",
        prop: "rentValueDate",
        width: "100",
        overHidden: true,
        formatter: (row, value, label, column) => {
          return `${dateConvert(value)}`;
        }
      },
      {
        label: "年租息率(%）",
        prop: "annualInterestRate",
        width: "100",
        formatter: (row, value, label, column) => {
          return value ? floatMul(Number(value) , 100) : ''
        },
        overHidden: true
      },
      {
        label: "内部收益率(%）",
        prop: "xirr",
        width: "120",
        formatter: (row, value, label, column) => {
          return value ? Number((value * 100)).toFixed(4) : ''
        },
        overHidden: true
      },
      // {
      //   label: '保理商',
      //   prop: "formAccountingEntity",
      //   type: "select",
      //   search: true,
      //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=rzzl_accounting_entity',
      //   dataType: 'number',
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   width: '280',

      // },
      {
        label: "业务主办",
        prop: "managerUserName",
        width: "100",
        overHidden: true
      },
      {
        label: "业务协办",
        prop: "assistUserName",
        width: "100",
        overHidden: true
      },
      {
        label: "所属部门",
        prop: "managerDeptName",
        width: "120",
        overHidden: true
      },
      {
        label: "创建日期",
        prop: "createTime",
        width: "150",
        overHidden: true
      }
    ]
  }
}
export function earnoutDetailConfig(getMoney) {
  return [{
      label: '放款金额',
      prop: 'quotationPrice',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '期数',
      prop: 'leaseTotal',
      span: '8',
      slot: true,
      formatter: (row, value, label, column) => {
        return `${value}期`;
      }
    },

    {
      label: '已还期数',
      prop: 'issueCovered',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${value}期`;
      }
    },
    {
      label: '回收成本总额',
      prop: 'totalPrincipalCovered',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '未回收成本',
      prop: 'totalPrincipalUncollected',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '利息收入总额',
      prop: 'totalInterest',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '已收利息收入',
      prop: 'totalInterestCovered',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '未收利息收入',
      prop: 'totalInterestUncovered',
      span: '8',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '批次',
      prop: 'investBatch',
      span: '8',
      formatter: (row, value, label, column) => {
        return value ? `第${value}批` : value;
      }
    },
    {
      label: '业务主办',
      prop: 'managerUserName',
      span: '8',
    },
    {
      label: '业务协办',
      prop: 'assistUserName',
      span: '8',
    },        

  ]

}
export function earnoutDetailListConfig(getMoney, dateConvert) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    // index: true,
    // indexLabel: "期数",
    refreshBtn: false,
    showSummary: true,
    // sumColumnList: [{
    //     label: '合计:',
    //     name: "expectedRent",
    //     type: "sum",
    //   },
    //   {
    //     label:' ',  
    //     name: "principal",
    //     type: "sum",
    //   },
    //   {
    //     label:' ',   
    //     name: "interest",

    //     type: "sum",
    //   },
    //   {
    //     label:' ',    
    //     name: "cashFlow",

    //     type: "sum",
    //   }
    // ],
    column: [{
        label: "期数",
        prop: "issue",
        overHidden: true,
        display: false,
        width: 50,

      },
      // {
      //   label: "租金日",
      //   fixed: true,
      //   prop: "rentDay",
      //   overHidden: true,
      //   display: false,
      //   slot: true,

      // },
      {
        label: "还款日",
        prop: "rentDay",
        overHidden: true,
        display: false,
        dataType: 'string',
        formatter: (row, value, label, column) => {
          return `${dateConvert(value)}`;
        }

      },
      {
        label: "每期保理首付款及保理首付款使用费合计额",
        prop: "expectedRent",
        // slot: true,
        overHidden: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        }
      },

      {
        label: "每期保理首付款",
        prop: "principal",

        overHidden: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        }
      },

      {
        label: "每期保理首付款使用费",
        prop: "interest",
        // slot: true,

        overHidden: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        }
      },

      {
        label: "剩余保理首付款",
        prop: "residualPrincipal",
        // slot: true,

        overHidden: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        }
      },

      {
        label: "现金流量",
        prop: "cashFlow",
        // slot: true,

        overHidden: true,
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}`;
        }
      },

      // {
      //   label: "手续费分摊",
      //   prop: "termFundTaken",
      //   // slot: true,

      //   overHidden: true,
      //   formatter: (row, value, label, column) => {
      //     return `${getMoney(value)}`;
      //   }
      // },
      {
        label: "备注",
        prop: "isWriteoff",
        slot:true,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=is_writeoff",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        

        
      },
    ]
  }
}
